import { render, staticRenderFns } from "./CreateAutoCampaign.vue?vue&type=template&id=4f8ca06a&scoped=true&"
import script from "./CreateAutoCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateAutoCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateAutoCampaign.vue?vue&type=style&index=0&id=4f8ca06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ca06a",
  null
  
)

export default component.exports